/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { Stack } from '@fluentui/react/lib/Stack';
import { Text } from '@fluentui/react/lib/Text';
import { Property } from 'csstype';
import * as React from 'react';
import { getStylist } from 'src/core/themes/luisStylist';

export type TitledSectionProps = {
    /**
     * The title of the section.
     */
    title: string;

    /**
     * The content.
     */
    children: React.ReactNode;
};

const { styleComponent } = getStylist('Dashboard');

const Title = styleComponent(Text)('Title', theme => ({
    textTransform: 'uppercase',
    fontSize: theme.xSmallFont,
    color: theme.defaultTextColor,
    lineHeight: theme.mediumLineHeight,
    letterSpacing: theme.xLargeLetterSpacing,
    fontWeight: theme.boldFont as Property.FontWeight
}));

/**
 * Displays a titled section with whitespace separates between the title
 * and the body (common case in the container card).
 */
export const TitledSection = (props: TitledSectionProps) => {
    const { title, children } = props;

    return (
        <Stack tokens={{ childrenGap: 16 }}>
            <Title>{title}</Title>
            {children}
        </Stack>
    );
};
